import React from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

import Permissions, { CAPABILITIES } from '../utils/Permissions'

import FAIcon from './FAIcon'

import './BottomNav.scss'

const BottomNav = props => {
  const location = useLocation()
  const caseMatch = location.pathname.match(/^\/cases\/(\d+)/)
  const caseNumber = caseMatch ? caseMatch[1] : null

  const appointmentPath = caseNumber ? `/cases/${caseNumber}/appointments` : '/appointments'
  const taskPath = caseNumber ? `/cases/${caseNumber}/tasks` : '/tasks/new'

  return (
    <Navbar className="bottom-nav" variant="dark" fixed="bottom">
      <div className="container">
        <Nav justify>
          <Nav.Item>
            <Nav.Link as={Link} to="/">
              <FAIcon name="home fa-lg" />
              <p className="nav-text">Home</p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/calendar">
              <FAIcon name="calendar fa-lg" fa-lg />
              <p className="nav-text">Calendar</p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="dropup">
            <button className="dropup-btn" onClick={props.handleOnSelect}>
              <FAIcon name="plus-circle fa-2x" />
            </button>
            {props.isDropdownToggled && (
              <ul id="drop-down" className="dropup-content">
                {Permissions.can(props.user, CAPABILITIES.CREATE_CASE) && (
                  <li>
                    <NewCaseLink />
                  </li>
                )}
                {Permissions.can(props.user, CAPABILITIES.CREATE_APPOINTMENT) && (
                  <li>
                    <Link
                      className="dropdown-item"
                      to={{ pathname: appointmentPath, state: { from: location.pathname } }}
                    >
                      New Appointment
                    </Link>
                  </li>
                )}
                {Permissions.can(props.user, CAPABILITIES.CREATE_TASK) && (
                  <li>
                    <Link className="dropdown-item" to={{ pathname: taskPath, state: { from: location.pathname } }}>
                      New Task
                    </Link>
                  </li>
                )}
              </ul>
            )}
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/cases">
              <FAIcon name="copy fa-lg" />
              <p className="nav-text">Cases</p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/library">
              <FAIcon name="bookmark fa-lg" />
              <p className="nav-text">Library</p>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </Navbar>
  )
}

function NewCaseLink() {
  const location = useLocation()
  return (
    <Link className="dropdown-item" to={{ pathname: '/case/intake/select-type', state: { from: location.pathname } }}>
      New Case
    </Link>
  )
}

export default BottomNav
